import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
  Row,
  Spinner,
  NavLink,
} from 'reactstrap';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import { connect } from 'react-redux';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import AddIntegration from './AddIntegration';
import AddVoucherIntregation from './AddVoucherIntegration';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { fetchServiceRequest } from '../../../../../redux/service/actions';
import {
  gAPI_Ingetration,
  API_Ingetration,
  gAPI_Property_List_By_Group,
  gAPI_Stripe_Connection,
  dAPI_Delete_Ingetration,
  postAPI_TrackEvent,
  gAPI_Site_Settings,
  gAPI_Internal_Property_By_Id,
  API_SMS_INTEGRATION
} from '../../../../../constants/APIs';

import FacebookIntegration from './FacebookIntegration';
import WebIntegrationThumb from './WebIntegrationThumb';
import FacebookIntegrationThumb from './FacebookIntegrationThumb';
import PhoneIntegrationThumb from './PhoneIntegrationThumb';
import PhoneIntegration from './PhoneIntegration';
import GoogleBuisnessIntegration from './GoogleBuisnessIntegration';
import GoogleBusinessIntegrationThumb from './GoogleBusinessIntegrationThumb';
import RevinateIntegration from './RevinateIntegration';
import WechatIntegration from './WechatIntegration';
import WechatIntegrationThumb from './WechatIntegrationThumb';
import StripeIntregation from './StripeIntregation';
import OpenAccount from './OpenAccount';
import ShowMessage from './ShowMessage';
import AddEmailIntegration from './Email/AddEmailIntegration';
import EmailIntegrationThumb from './Email/EmailIntegrationThumb';
import IntlMessages from '../../../../../helpers/IntlMessages';
import bot_icon from './../../../../../assets/bot_icon1.png';

import WechatLogo from '../../../../../assets/wechat_icon.png';
import InstaLogo from '../../../../../assets/insta_logo.png';
import TiktokIntegrationThumb from './TikTok/TiktokIntegrationThumb';
import TiktokIntegration from './TikTok/TiktokIntegration';
import GmailIntegration from './Gmail/GmailIntegration';
import GmailIntegrationThumb from './Gmail/GmailIntegrationThumb';
import MessengerX from '../../../../../assets/Website icon.png';
import EmailLogo from '../../../../../assets/email_icon.png';
import PhoneLogo from '../../../../../assets/phone_icon.png';
import WhatsApp_Logo from '../../../../../assets/whatsapp_icon.svg';
import SMS_Logo from '../../../../../assets/sms.svg';
import Group_Logo from '../../../../../assets/Group icon.png';
import FB_logo from '../../../../../assets/fb_logo.png';
import Google_Icon from '../../../../../assets/google_icon.png';
import Phone_Logo from '../../../../../assets/phone_logo.png';

import RMSIntegration from './RMSIntegration';
import SiteminderIntegration from './SiteminderIntegration';
import AmadeusIntegration from './AmadeusIntegration';

import BookingEngineUrlIntegration from './BookingEngineUrlIntegration';

import AddServiceStandalonePageIntegration from './ServiceStandalone/AddServiceStandalonePageIntegration';
import AddEmbedPageIntegration from './EmbedPage/AddEmbedPageIntegration';
import ShowWarningMessage from './ShowWarningMessage';
import SalesforceIntegration from './SalesforceIntegration';
import AddStandaloneGuestServicePageIntegration from './GuestServiceStandalone/AddStandaloneGuestServicePageIntegration';
import WhatsappIntegration from './WhatsApp/WhatsappIntegration';
import CloudBeds_Logo from '../images/cloudBeds_logo.png';
import SMSIntegration from './SMS/SmsIntegrations';
import SMSIntegrationThumb from './SMS/SmsIntegrationThumb';
import WhatsappIntegrationThumb from './WhatsApp/WhatsappIntegrationThumb';
import OracleOperaIntegration from './OracleOpera/OracleOperaIntegration';
import AddHelpCenterIntegration from './HelpCenter/AddHelpCenterIntegration';
import HelpCenterIntegrationThumb from './HelpCenter/HelpCenterIntegrationThumb';
import GoogleAnalyticsIntegration from './GoogleAnalyticsIntegration';
import Analytics_Logo from './../../../../../assets/google_analytics.png';
import AddHelpCenterGroupIntegration from './HelpCenterGroup/AddHelpCenterGroupIntegration';
import HelpCenterGroupIntegrationThumb from './HelpCenterGroup/HelpCenterGroupIntegrationThumb';
import AddSpaceStandAlonePageIntegration from './SpaceStandalone/AddSpaceStandalonePageIntegration';
import PhoneSuiteIntegration from './PhoneSuite/PhoneSuiteIntegration';
import PhoneSuiteIntegrationThumb from './PhoneSuite/PhoneSuiteIntegrationThumb';
import WebRTCIntegration from './WebRTC/WebRTCIntegration';
import { changeTabs } from '../../../../../redux/actions';
import SHRCRSIntegration from './SHRCRS/SHRCRSIntegration';
import InstagramIntegrationThumb from './InstagramIntegrationThumb';
import InstagramIntegration from './InstagramIntegration';
import AmazonIntegration from './Amazon/AmazonIntegration';
import TeamsAppIntegration from './TeamsApp/TeamsAppIntegration';
import TeamsAppIntegrationThumb from './TeamsApp/TeamsAppIntegrationThumb';
import TeamsApp_Logo from '../../../../../assets/ms-teamsapp-icon.svg';
import NewbookIntegration from './NewbookIntegration';
import { faGoogle, faTiktok } from '@fortawesome/free-brands-svg-icons';
import GMailIcon from '../../../../../assets/gmail.png';
import OutlookIcon from '../../../../../assets/outlook.png';
function Channel({
  match,
  propertyId,
  email,
  isVoucherEngine,
  changeTabs,
  domains,
  locale,
  integrationTab,
  serviceProvider,
  featuresUrl,
  fetchServiceRequest,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [integrations, setIntegrations] = useState([]);
  const [fbintegrations, setfbIntegrations] = useState([]);
  const [stripeIntregation, setStripeIntregations] = useState([]);
  const [phoneintegrations, setPhoneIntegrations] = useState([]);
  const [gbintegrations, setGbIntegrations] = useState([]);
  const [revinateintegrations, setRevinateIntegrations] = useState([]);
  const [weChatintegrations, setWeChatIntegrations] = useState([]);
  const [voucherWebsiteIntregation, setVoucherWebsiteIntregation] = useState(
    []
  );
  const [instagramIntegrations, setInstagramIntegrations] = useState([]);
  const [tiktokIntegrations, setTiktokIntegrations] = useState([]);
  const [gmailIntegrations, setGmailIntegrations] = useState([]);
  const [amadeusIntegration, setAmadeusIntegration] = useState([]);
  const [bookingEngineUrlIntegration, setBookingEngineUrlIntegration] =
    useState([]);
  const [standalonePageIntegration, setStandalonePageIntegration] = useState(
    []
  );
  const [webRTCIntegrations, setWebRTCIntegrations] = useState([]);
  const [embedPageIntegration, setEmbedPageIntegration] = useState([]);
  const [phoneSuiteIntegrations, setPhoneSuiteIntegrations] = useState([]);
  const [
    standaloneGuestServicePageIntegration,
    setStandaloneGuestServicePageIntegration,
  ] = useState([]);
  const [whatsAppintegrations, setWhatsAppIntegrations] = useState([]);
  const [SMSintegrations, setSMSIntegrations] = useState([]);
  const [oracleOperaIntegration, setOracleOperaIntegration] = useState([]);
  const [helpCenterIntegration, setHelpCenterIntegration] = useState([]);
  const [helpCenterGroupIntegration, setHelpCenterGroupIntegration] = useState(
    []
  );
  const [emailIntegration, setEmailIntegration] = useState([]);
  const [selectedTab, setSelectedTab] = useState('Connected Channels');
  const [activeTab, setActiveTab] = useState('standard');
  const [allProperties, setAllProperties] = useState([]);
  //disable channel
  const [disableChannelsList, setDisableChannelsList] = useState([]);

  const [rmsBookingEngineData, setRMSBookingEngineList] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [isAddFB, setIsAddFB] = useState(false);
  const [isAddPhone, setIsAddPhone] = useState(false);
  const [isAddRevinate, setIsAddRevinate] = useState(false);
  const [isAddWechat, setIsAddWechat] = useState(false);
  const [isAddGb, setIsAddGb] = useState(false);
  const [isAddInsta, setIsAddInsta] = useState(false);
  const [isAddTiktok, setIsAddTiktok] = useState(false);
  const [isAddGmail, setIsAddGmail] = useState(false);
  const [isWebRTCIntegration, setIsWebRTCIntegration] = useState(false);
  const [isAddPhoneSuite, setIsPhoneSuite] = useState(false);
  const [isGoogleAnalyticsAvailable, setIsGoogleAnalyticsAvailable] =
    useState(false);
  const [isAddEmail, setIsAddEmail] = useState(false);
  const [outlookAddon, setOutlookAddon] = useState(false);
  const [messageVisible, setmessageVisible] = useState(
    localStorage.getItem('ShowMessage')
      ? localStorage.getItem('ShowMessage')
      : false
  );
  const [cloudBedsVisible, setCloudsBedsVisible] = useState(
    localStorage.getItem('ShowCloudbedsMessage')
      ? localStorage.getItem('ShowCloudbedsMessage')
      : false
  );

  const [instagramVisible, setInstagramVisible] = useState(
    localStorage.getItem('ShowInstagramMessage')
      ? localStorage.getItem('ShowInstagramMessage')
      : false
  );

  const [tiktokVisible, setTiktokVisible] = useState(
    localStorage.getItem('ShowTiktokMessage')
      ? localStorage.getItem('ShowTiktokMessage')
      : false
  );

  const [confirmMessage, setConfirmMeesage] = useState(
    localStorage.getItem('ShowConfirm')
      ? localStorage.getItem('ShowConfirm')
      : false
  );

  const [paymentmodelvisible, setpaymentmodelvisible] = useState(false);
  const [createaccountModel, setcreateaccountModel] = useState(false);
  const [isConnected, setisConnected] = useState(false);
  const [stripeIntegrationId, setStripeIntegrationId] = useState('');
  const [stripepropertyId, setStripeProprtyId] = useState('');
  const [isAddVouchers, setIsAddVouchers] = useState(false);
  const [isAddRms, setIsAddRms] = useState(false);
  const [isAddSiteminder, setIsSiteminderb] = useState(false);
  const [isAddAmadeus, setIsAmadeus] = useState(false);
  const [isAddBookingEngine, setIsAddBookingEngine] = useState(false);
  const [isAddStandalonePage, setIsAddStandalonePage] = useState(false);
  const [isAddEmbedPage, setIsAddEmbedPage] = useState(false);
  const [isAddStandaloneGuestServicePage, setIsAddStandaloneGuestServicePage] =
    useState(false);
  const [isSalesforce, setIsSalesforce] = useState(false);
  const [isAddWhatsApp, setIsAddWhatsApp] = useState(false);
  const [isAddSMS, setIsAddSMS] = useState(false);
  const [isAddOracleOpera, setIsAddOracleOpera] = useState(false);
  const [isAddHelpCenter, setIsAddHelpCenter] = useState(false);
  const [isAddHelpCenterGroup, setIsAddHelpCenterGroup] = useState(false);
  const [salesforceIntegration, setSalesforceIntegration] = useState([]);
  const [warningMsgVisible, setWarningMsgVisible] = useState(false);
  const [cloudBeds, setCloudsBeds] = useState([]);
  const [isCloudBeds, setIsCloudsBeds] = useState(false);
  const [googleAnalytics, setGoogleAnalytics] = useState([]);
  const [isGoogleAnalytics, setIsGoogleAnalytics] = useState(false);
  const [spaceStandAloneList, setSpaceStandAloneList] = useState([]);
  const [isSpaceStandalonePage, setIsSpaceStandAlonePage] = useState(false);

  const [sabreIntegrationList, setSabreIntegrationList] = useState([]);
  const [isSabreIntegrationPage, setIsSabreIntegrationPage] = useState(false);

  const [restApiIntegrationList, setRESTApiIntegrationList] = useState([]);
  const [isRESTApiIntegrationPage, setIsRESTApiIntegrationPage] =
    useState(false);
  const [isAddMews, setIsAddMews] = useState(false);
  const [mewsIntegrationList, setMewsIntegrationList] = useState([]);
  const [isAddSHR, setIsAddSHR] = useState(false);
  const [shrCRSIntegrationList, setSHRCRSIntegrationList] = useState();
  const [isAddAmazon, setIsAddAmazon] = useState(false);
  const [amazonIntegration, setAmazonIntegration] = useState([]);
  const [isAddTeamsApp, setIsAddTeamsApp] = useState(false);
  const [teamsAppintegrations, setTeamsAppIntegrations] = useState([]);
  const [unifiedEmailIntegrationsList, setUnifiedEmailIntegrationsList] =
    useState([]);
  const [isUnifiedEmailIntegration, setIsUnifiedEmailIntegration] =
    useState(false);
  const [isVoice, setIsVoice] = useState(false);
  const [isChatbot, setIsChatbot] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [isGuestMessaging, setIsGuestMessaging] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [isGmail, setIsGmail] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  const [filterProperty, setFilterProperty] = useState(null);
  const [filterChannel, setFilterChannel] = useState(null);
  const [isAddNewbook, setIsAddNewbook] = useState(false);
  const [newbookBookingEngineData, setNewbookBookingEngineList] = useState([]);
  const [gmailIntegrationList, setGmailIntegrationList] = useState([]);

  const CHANNEL_NAMES = {
    integrations: "AI Chatbot",
    // gbintegrations: "Google Business",
    whatsAppintegrations: "WhatsApp",
    Smsintegrations: "Sms",
    helpCenterIntegration: "Property Widget",
    helpCenterGroupIntegration: "Group Widget",
    instagramIntegrations: "Instagram",
    tiktokIntegrations: "TikTok",
    gmailIntegrations: "Gmail",
    weChatintegrations: "WeChat",
    // phoneintegrations: "Phone",
    fbintegrations: "Facebook",
    phoneSuiteIntegrations: "Voice AI",
    emailIntegration: "Email",
    // unifiedEmailIntegrationsList: "Email",
    teamsAppintegrations: "Teams App",
  };
  const propertyOptions = [
    { label: "All Properties", value: "" },
    ...(
      allProperties?.map((p) => ({
        label: p.name,
        value: p.id,
      })) || []
    ),
  ];
  const channelOptions = [
    { label: "All Channel", value: "" },
    ...Object.values(CHANNEL_NAMES).map((name) => ({
      label: name,
      value: name,
    })),
  ];


  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);

  const handleProerptyId = (id) => {
    setStripeProprtyId(id);
  };
  const imageDomain =
    featuresUrl && !featuresUrl.includes('myma.ai')
      ? `https://assets.${featuresUrl}`
      : 'https://assets.bookmebob.com';

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
      // setIsLoading(false);
    });
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Integrations',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => { }
      );
    }
    // Fetch property details by ID
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        const data = res.data;
        console.log(1234, data)
        setIsVoice(data.isAIVoice || false);
        setIsSocial(data.isSocialChannel || false);
        setIsGuestMessaging(data.isGuestMessaging || false);
        setIsChatbot(data.isBmb || false);
        setIsEmail(data.isEmailAutomation || false);
      })
      .catch((err) => console.error(err));
  }, [propertyId]);

  const checkConnection = () => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/check`,
      data,
    })
      .then((m) => {
        if (m.data.stripeCustomerId == '') {
        }
        setStripeIntegrationId(m.data.stripeCustomerId);
      })
      .catch((err) => { });
  };
  const RefreshConnection = (status, id) => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Creator: 'Admin',
      StripeCustomerId: status === 'Archieve' ? '' : stripeIntegrationId,
      StripeStatus: status,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/save`,
      data: data,
    })
      .then((res) => {
        if (status === 'Archieve') {
          AxiosAPI({
            method: 'delete',
            url: `${gAPI_Stripe_Connection}/remove?id=${id}`,
            data: data,
          })
            .then((res) => { })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  };
  const handlePayment = () => {
    var restUrl = window.location.href.substring(
      0,
      window.location.href.lastIndexOf('/') + 1
    );
  };

  useEffect(() => {
    checkConnection();
  }, []);
  const LoadIntegrations = () => {
    setIsLoading(true);
    let body = {
      channels: [
        'WebsiteDirectLine',
        'RMSBookingEngine',
        'FacebookDirectLine',
        'Phone',
        'GoogleBusinessMessage',
        'Revinate',
        'RESTAPI',
        'WeChat',
        'SHRCRS',
        'Amadues',
        'BookingEngineUrl',
        'ServiceStandAlonePage',
        'EmbedService',
        'Salesforce',
        'GuestServiceStandAlonePage',
        'WhatsApp',
        'Sms',
        'OracleOpera',
        'HelpCenter',
        'Sabre',
        'InstagramDirectLine',
        'SHRCRS',
        'CloudBeds',
        'EmailAssistant',
        'Mews',
        'GoogleAnalytics',
        'HelpCenterGroup',
        'SpaceStandalone',
        'PhoneSuite',
        'WebRTC',
        'EmailDirectLine',
        'Amazon',
        'TikTokDirectLine',
        'TeamsApp',
        'NewbookBookingEngine',
        'Gmail'
      ],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        filteringIntegrations(integrations);

        const mewsIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Mews')
        );
        const amazonIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Amazon')
        );
        const emailIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'EmailDirectLine')
        );
        const gmailIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Gmail')
        );
        const sabreIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Sabre')
        );
        const rmsBookingData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'RMSBookingEngine')
        );
        const restAPIIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'RESTAPI')
        );

        const webRTCIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WebRTC')
        );
        const instagramIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'InstagramDirectLine')
        );
        const tiktokIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel && k.channel.toLowerCase().includes('tiktok'))
        );
        const phoneSuiteIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'PhoneSuite')
        );
        const googleAnalyticsInegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'GoogleAnalytics')
        );
        const cloudsBedsIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'CloudBeds')
        );
        const whatsAppIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WhatsApp')
        );
        const SmsIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Sms')
        );

        const oracleOperaIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'OracleOpera')
        );
        const helpCenterIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'HelpCenter')
        );
        const helpCenterGroupIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'HelpCenterGroup')
        );
        const spaceStandAloneIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'SpaceStandalone')
        );

        // const instagramIntegrationData = res.data.filter(
        //     (k) => k.channel === 'InstagramDirectLine'
        // );

        const shrCRSIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'SHRCRS')
        );
        const webIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WebsiteDirectLine')
        );

        const fbIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'FacebookDirectLine')
        );
        const phoneIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Phone')
        );
        const gbIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'GoogleBusinessMessage')
        );
        const revinateIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Revinate')
        );
        const wechatIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'WeChat')
        );
        const amadeusIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Amadues')
        );
        const bookingEngineUrlIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'BookingEngineUrl')
        );
        const standalonePageIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'ServiceStandAlonePage')
        );
        const embedPageIntegration = filteringIntegrations(
          res.data.filter((k) => k.channel === 'EmbedService')
        );
        const salesforceIntegrationData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'Salesforce')
        );
        const standaloneGuestServicePageData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'GuestServiceStandAlonePage')
        );
        const teamsAppIntegrationData = res.data.filter(
          (k) => k.channel === 'TeamsApp'
        );

        const outlookAssistant = res.data.filter(
          (k) => k.channel === 'EmailAssistant'
        );
        const newbookBookingData = filteringIntegrations(
          res.data.filter((k) => k.channel === 'NewbookBookingEngine')
        );

        setGmailIntegrationList(gmailIntegrationData);
        setUnifiedEmailIntegrationsList(outlookAssistant);
        setEmailIntegration(emailIntegrationData);
        setSabreIntegrationList(sabreIntegrationData);
        setMewsIntegrationList(mewsIntegrationData);
        setRMSBookingEngineList(rmsBookingData);
        setRESTApiIntegrationList(restAPIIntegrationData);
        setSHRCRSIntegrationList(shrCRSIntegration);
        setWebRTCIntegrations(webRTCIntegrationData);
        setInstagramIntegrations(instagramIntegrationData);
        setTiktokIntegrations(tiktokIntegrationData);
        setPhoneSuiteIntegrations(phoneSuiteIntegrationData);
        // console.log(spaceStandAloneIntegrationData);
        setSpaceStandAloneList(spaceStandAloneIntegrationData);
        setGoogleAnalytics(googleAnalyticsInegration);
        setCloudsBeds(cloudsBedsIntegration);
        // console.log(salesforceIntegrationData);
        setSalesforceIntegration(salesforceIntegrationData);
        setIntegrations(webIntegrationData);
        setfbIntegrations(fbIntegrationData);
        setPhoneIntegrations(phoneIntegrationData);
        setGbIntegrations(gbIntegrationData);
        setRevinateIntegrations(revinateIntegrationData);
        setWeChatIntegrations(wechatIntegrationData);
        setStripeIntregations([]);
        setVoucherWebsiteIntregation([]);
        setAmadeusIntegration(amadeusIntegration);
        setBookingEngineUrlIntegration(bookingEngineUrlIntegrationData);
        setStandalonePageIntegration(standalonePageIntegration);
        setEmbedPageIntegration(embedPageIntegration);
        setStandaloneGuestServicePageIntegration(
          standaloneGuestServicePageData
        );
        setWhatsAppIntegrations(whatsAppIntegrationData);
        setSMSIntegrations(SmsIntegrationData);
        setOracleOperaIntegration(oracleOperaIntegrationData);
        setHelpCenterIntegration(helpCenterIntegrationData);
        setHelpCenterGroupIntegration(helpCenterGroupIntegrationData);
        setAmazonIntegration(amazonIntegrationData);
        setTeamsAppIntegrations(teamsAppIntegrationData);
        setNewbookBookingEngineList(newbookBookingData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const filteringIntegrations = (integrations) => {
    if (Array.isArray(integrations)) {
      return integrations.filter((integration) => {
        if (
          disableChannelsList?.length > 0 &&
          disableChannelsList?.some(
            (channel) =>
              integration?.channel.toLowerCase() === channel.toLowerCase()
          )
        ) {
          return false;
        }
        return true;
      });
    }
    return integrations;
  };
  //filter available channels
  const filterItem = (channelName) => {
    if (
      disableChannelsList?.length > 0 &&
      disableChannelsList?.some(
        (channel) => channelName.toLowerCase() === channel.toLowerCase()
      )
    ) {
      return false;
    }
    return true;
  };
  const fetchService = (serviceProvider) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Site_Settings}`,
    })
      .then((res) => {
        const matchedService = res.data.find(
          (item) => item.id.toString() === serviceProvider
        );
        if (matchedService) {
          const disableChannels = matchedService?.disableChannels || [];
          setDisableChannelsList(disableChannels);
        } else {
          console.log('No matched service found or disableChannels is empty');
        }
      })
      .catch((err) => {
        console.error('Error fetching service provider:', err);
      });
  };

  useEffect(() => {
    LoadIntegrations();
  }, [disableChannelsList]);

  useEffect(() => {
    fetchService(serviceProvider);
  }, [serviceProvider]);

  const handleDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      LoadIntegrations();
    });
  };
  const handleTabs = (tabs) => {
    changeTabs(tabs);
    setSelectedTab(tabs);
  };

  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };
  const toggleWarning = () => {
    setWarningMsgVisible(!warningMsgVisible);
  };

  const applyFilters = (list, channelName) => {
    return list.filter((integration) => {
      let matchesProperty = true;
      let matchesChannel = true;

      // Property filter
      if (filterProperty && filterProperty.value !== "") {
        matchesProperty = integration.properties?.includes(
          filterProperty.value
        );
      }

      // Channel filter
      if (filterChannel && filterChannel.value !== "") {
        matchesChannel = filterChannel.value === channelName;
      }

      return matchesProperty && matchesChannel;
    });
  };

  return (
    <Fragment>
      <CardHeader className="mb-2">
        <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
          <NavItem
            className=" text-center"
            style={{ width: 'auto', background: '' }}
          >
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'Available Channels',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('Available Channels');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${selectedTab === 'Available Channels'
                    ? 'var(--theme-color-1)'
                    : '#8f8f8f'
                    }`,
                }}
              >
                Available Channels
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'Connected Channels',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('Connected Channels');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${selectedTab === 'Connected Channels'
                    ? 'var(--theme-color-1)'
                    : '#8f8f8f'
                    } `,
                }}
              >
                Connected Channels
              </span>
            </NavLink>
          </NavItem>
          {selectedTab === "Connected Channels" && (
            <div className="ml-auto mr-4 voucher-preview">

              <Button
                size="xs"
                color="grey"
                outline
                onClick={() => setIsFiltering(!isFiltering)}
              >
                <div className="d-flex">
                  <FontAwesomeIcon icon={faFilter} className="fa mr-1" style={{ paddingTop: '4px' }} />
                  <IntlMessages id="menu.show-filter" />
                  <div className="ml-1" style={{ marginTop: '2px' }}>
                    {isFiltering ? (
                      <i className="simple-icon-arrow-up p-1"></i>
                    ) : (
                      <i className="simple-icon-arrow-down p-1"></i>
                    )}
                  </div>
                </div>
              </Button>
            </div>
          )}
        </Nav>

        {/* FILTER PANEL */}
        {selectedTab === "Connected Channels" && isFiltering && (
          <Card
            className="filter-width  mt-2 mr-4"
            style={{
              float: 'right',
              position: 'absolute',
              zIndex: 1,
              top: '7rem',
              right: '3rem',
              marginLeft: '0rem',
              boxShadow:
                '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
            }}
          >
            <CardBody>
              <Colxx md="12">
                <Row>
                  {/* Filter: PROPERTY */}
                  <Colxx xxs="12" md="12" className="mb-2">
                    <Select
                      className="react-select"
                      classNamePrefix="react-select"
                      name="property-filter"
                      placeholder="Filter by Property"
                      value={filterProperty}
                      onChange={(v) => setFilterProperty(v)}
                      options={propertyOptions}
                    />
                  </Colxx>

                  {/* Filter: CHANNEL NAME */}
                  <Colxx xxs="12" md="12" className="mb-2">
                    <Select
                      className="react-select"
                      classNamePrefix="react-select"
                      name="channel-filter"
                      placeholder="Filter by Channel"
                      value={filterChannel}
                      onChange={(v) => setFilterChannel(v)}
                      options={channelOptions}
                    />
                  </Colxx>

                  {/* Filter Buttons */}
                  <Colxx xxs="12" md="12">
                    {/* <Button
                      size="xs"
                      color="primary"
                      className="mb-2 mt-2"
                      onClick={() => setIsFiltering(false)}
                    >
                      Search
                    </Button> */}

                    <Button
                      size="xs"
                      color="secondary"
                      className="mb-2 ml-2 mt-2"
                      onClick={() => {
                        setFilterChannel(null);
                        setFilterProperty(null);
                        setIsFiltering(false);
                      }}
                    >
                      Reset
                    </Button>
                  </Colxx>
                </Row>
              </Colxx>
            </CardBody>
          </Card>
        )}


      </CardHeader>
      <Fragment>
        {isAdd ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddIntegration
                    visible={isAdd}
                    toggle={() => {
                      setIsAdd(!isAdd);
                    }}
                    imageDomain={imageDomain}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddVouchers ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddVoucherIntregation
                    visible={isAddVouchers}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsAddVouchers(!isAddVouchers);
                    }}
                    imageDomain={imageDomain}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddFB ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <FacebookIntegration
                    visible={isAddFB}
                    propertyId={propertyId}
                    toggle={() => {
                      setIsAddFB(!isAddFB);
                    }}
                    LoadIntegrations={LoadIntegrations}
                    allProperties={allProperties}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isSpaceStandalonePage ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddSpaceStandAlonePageIntegration
                    visible={isSpaceStandalonePage}
                    propertyId={propertyId}
                    toggle={() => {
                      setIsSpaceStandAlonePage(!isSpaceStandalonePage);
                    }}
                    LoadIntegrations={LoadIntegrations}
                    allProperties={allProperties}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddPhone ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <PhoneIntegration
                    visible={isAddPhone}
                    toggle={() => {
                      setIsAddPhone(!isAddPhone);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddInsta ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <InstagramIntegration
                    LoadIntegrations={LoadIntegrations}
                    visible={isAddInsta}
                    toggle={() => {
                      setIsAddInsta(!isAddInsta);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddTiktok ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <TiktokIntegration
                    LoadIntegrations={LoadIntegrations}
                    visible={isAddTiktok}
                    toggle={() => {
                      setIsAddTiktok(!isAddTiktok);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddGmail ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <GmailIntegration
                    LoadIntegrations={LoadIntegrations}
                    visible={isAddGmail}
                    toggle={() => {
                      setIsAddGmail(!isAddGmail);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddGb ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <GoogleBuisnessIntegration
                    visible={isAddGb}
                    toggle={() => {
                      setIsAddGb(!isAddGb);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddRms ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <RMSIntegration
                    visible={isAddRms}
                    toggle={() => {
                      setIsAddRms(!isAddRms);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddSiteminder ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <SiteminderIntegration
                    visible={isAddSiteminder}
                    toggle={() => {
                      setIsSiteminderb(!isAddSiteminder);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddRevinate ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <RevinateIntegration
                    visible={isAddRevinate}
                    toggle={() => {
                      setIsAddRevinate(!isAddRevinate);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isSalesforce ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <SalesforceIntegration
                    visible={isSalesforce}
                    toggle={() => {
                      setIsSalesforce(!isSalesforce);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isWebRTCIntegration ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <WebRTCIntegration
                    visible={isWebRTCIntegration}
                    toggle={() => {
                      setIsWebRTCIntegration(!isWebRTCIntegration);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddWechat ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <WechatIntegration
                    visible={isAddWechat}
                    toggle={() => {
                      setIsAddWechat(!isAddWechat);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddAmadeus ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AmadeusIntegration
                    visible={isAddAmadeus}
                    toggle={() => {
                      setIsAmadeus(!isAddAmadeus);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddSHR ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <SHRCRSIntegration
                    visible={isAddSHR}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsAddSHR(!isAddSHR);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddPhoneSuite ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <PhoneSuiteIntegration
                    visible={isAddPhoneSuite}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsPhoneSuite(!isAddPhoneSuite);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddBookingEngine ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <BookingEngineUrlIntegration
                    visible={isAddBookingEngine}
                    toggle={() => {
                      setIsAddBookingEngine(!isAddBookingEngine);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddStandalonePage ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddServiceStandalonePageIntegration
                    visible={isAddStandalonePage}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsAddStandalonePage(!isAddStandalonePage);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddEmbedPage ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddEmbedPageIntegration
                    visible={isAddEmbedPage}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsAddEmbedPage(!isAddEmbedPage);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddStandaloneGuestServicePage ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddStandaloneGuestServicePageIntegration
                    visible={isAddStandaloneGuestServicePage}
                    LoadIntegrations={LoadIntegrations}
                    toggle={() => {
                      setIsAddStandaloneGuestServicePage(
                        !isAddStandaloneGuestServicePage
                      );
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddWhatsApp ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <WhatsappIntegration
                    visible={isAddWhatsApp}
                    toggle={() => {
                      setIsAddWhatsApp(!isAddWhatsApp);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddOracleOpera ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <OracleOperaIntegration
                    visible={isAddOracleOpera}
                    toggle={() => {
                      setIsAddOracleOpera(!isAddOracleOpera);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddHelpCenter ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddHelpCenterIntegration
                    visible={isAddHelpCenter}
                    toggle={() => {
                      setIsAddHelpCenter(!isAddHelpCenter);
                    }}
                    imageDomain={imageDomain}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddHelpCenterGroup ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddHelpCenterGroupIntegration
                    visible={isAddHelpCenterGroup}
                    toggle={() => {
                      setIsAddHelpCenterGroup(!isAddHelpCenterGroup);
                    }}
                    imageDomain={imageDomain}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isGoogleAnalytics ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <GoogleAnalyticsIntegration
                    visible={isGoogleAnalytics}
                    toggle={() => {
                      setIsGoogleAnalytics(!isGoogleAnalytics);
                    }}
                    serviceProvider={serviceProvider}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddEmail ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddEmailIntegration
                    visible={isAddEmail}
                    toggle={() => {
                      setIsAddEmail(!isAddEmail);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isUnifiedEmailIntegration ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AddEmailIntegration
                    visible={isUnifiedEmailIntegration}
                    channel={'EmailAssistant'}
                    toggle={() => {
                      setIsUnifiedEmailIntegration(!isUnifiedEmailIntegration);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}

        {isAddAmazon ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <AmazonIntegration
                    visible={isAddAmazon}
                    toggle={() => {
                      setIsAddAmazon(!isAddAmazon);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddTeamsApp ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <TeamsAppIntegration
                    visible={isAddTeamsApp}
                    toggle={() => {
                      setIsAddTeamsApp(!isAddTeamsApp);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddSMS ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <SMSIntegration
                    visible={isAddSMS}
                    toggle={() => {
                      setIsAddSMS(!isAddSMS);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}
        {isAddNewbook ? (
          <Row>
            <Colxx xxs="12">
              <Row>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12">
                  <NewbookIntegration
                    visible={isAddNewbook}
                    toggle={() => {
                      setIsAddNewbook(!isAddNewbook);
                    }}
                  />
                </Colxx>
                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
              </Row>
            </Colxx>
          </Row>
        ) : null}

        <Fragment>
          <TabContent activeTab={selectedTab} className="">
            <TabPane
              tabId="Available Channels"
              className="chat-app-tab-pane"
              style={{ background: 'none' }}
            >
              <Row className="m-2 my-3">
                <Fragment>
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('HelpCenter') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={MessengerX}
                                    style={{ maxWidth: '50px' }}
                                  ></img>
                                </div>
                                {!isChatbot ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsAddHelpCenter(!isAddHelpCenter)
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Web Widget for Property Website</h2>
                                    <span>
                                      Give proactive help, and personal
                                      assistance through forms, workflows, and
                                      AI chatbot.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('HelpCenterGroup') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={Group_Logo}
                                    style={{ maxWidth: '50px' }}
                                  ></img>
                                </div>
                                {!isChatbot ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsAddHelpCenterGroup(
                                        !isAddHelpCenterGroup
                                      )
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Web Widget for Group Website</h2>
                                    <span>
                                      Give proactive help, and personal
                                      assistance through forms, workflows, and
                                      AI chatbot.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('WebsiteDirectLine') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={bot_icon}
                                    style={{ width: '30px' }}
                                  ></img>
                                </div>
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                  onClick={() => setIsAdd(!isAdd)}
                                >
                                  <IntlMessages id="dashboards.connect" />
                                </Button>
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>AI Chatbot for Web Widget</h2>
                                    <span>
                                      Respond to guest questions with
                                      breakthrough Generative AI technology.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('GoogleBusinessMessage') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={Google_Icon}
                                    style={{ width: '2rem' }}
                                  ></img>
                                </div>
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                  onClick={() => setIsAddGb(!isAddGb)}
                                >
                                  Feature discontinued by Google
                                </Button>
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Google Business Messages</h2>
                                    <span>
                                      Enable Chat button in Google Maps and
                                      automate responses. Manage and reply to
                                      conversations from a unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('FacebookDirectLine') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={FB_logo}
                                    style={{ width: '3rem' }}
                                  ></img>
                                </div>
                                {!isSocial ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddFB(!isAddFB)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Facebook Messenger</h2>
                                    <span>
                                      Automate responses to Facebook messages.
                                      Manage and reply to conversations from a
                                      unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('WhatsApp') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={WhatsApp_Logo}
                                    style={{ width: '3rem' }}
                                  ></img>
                                </div>
                                {!isSocial ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"


                                  >
                                    <span>Not Available</span>
                                  </Button>

                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsAddWhatsApp(!isAddWhatsApp)
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>WhatsApp</h2>
                                    <span>
                                      Automate responses to WhatsApp messages.
                                      Manage and reply to conversations from a
                                      unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('Sms') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={SMS_Logo}
                                    style={{ width: '2rem' }}
                                  ></img>
                                </div>
                                {!isGuestMessaging ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"


                                  >
                                    <span>Not Available</span>
                                  </Button>

                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsAddSMS(!isAddSMS)
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2.5rem' }}
                                >
                                  <div className="text-left">
                                    <h2>SMS</h2>
                                    <span>
                                      Automate responses to SMS messages.
                                      Manage and reply to conversations from a
                                      unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('InstagramDirectLine') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={InstaLogo}
                                    style={{ width: '2.5rem' }}
                                  ></img>
                                </div>
                                {!isSocial ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"


                                  >
                                    <span>Not Available</span>
                                  </Button>

                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddInsta(!isAddInsta)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Instagram</h2>
                                    <span>
                                      Automate responses to Instagram private
                                      messages. Manage and reply to
                                      conversations from a unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                      {filterItem('TikTok') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <FontAwesomeIcon icon={faTiktok} size="2x" />
                                </div>
                                {!isSocial ? (
                                  <Button size="xs" color="outline-grey">
                                    <span>Not Available</span>
                                  </Button>
                                ) : (
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddTiktok(!isAddTiktok)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                )}
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>TikTok</h2>
                                    <span>
                                      Automate responses to TikTok messages. Manage and reply to conversations from a unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                      {filterItem('Gmail') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img src={GMailIcon} alt="gmail" style={{ width: '30px', height: '30px' }} />
                                </div>
                                {!isSocial ? (
                                  <Button size="xs" color="outline-grey">
                                    <span>Not Available</span>
                                  </Button>
                                ) : (
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddGmail(!isAddGmail)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                )}
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Email Automation with Gmail</h2>
                                    <span>
                                      Automate email drafting and replies in Gmail using AI for faster, consistent communication.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('EmailAssistant') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={OutlookIcon}
                                    style={{ width: '2.5rem' }}
                                  ></img>
                                </div>
                                {!isEmail ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsUnifiedEmailIntegration(
                                        !isUnifiedEmailIntegration
                                      )
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Email Automation with Microsoft 365</h2>
                                    <span>
                                      Automate email drafting and replies in Microsoft 365 using AI for faster, consistent communication.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('WeChat') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={WechatLogo}
                                    style={{ width: '3rem' }}
                                  ></img>
                                </div>
                                {!isSocial ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"


                                  >
                                    <span>Not Available</span>
                                  </Button>

                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddWechat(!isAddWechat)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>WeChat</h2>
                                    <span>
                                      Automate responses to WeChat messages.
                                      Manage and reply to conversations from a
                                      unified inbox.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('Phone') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={Phone_Logo}
                                    style={{ width: '2.5rem' }}
                                  ></img>
                                </div>
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                  onClick={() => setIsAddPhone(!isAddPhone)}
                                >
                                  <IntlMessages id="dashboards.connect" />
                                </Button>
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Telephony with Amazon Connect </h2>
                                    <span>
                                      Automate phone communication using Voice
                                      AI
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('PhoneSuite') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={PhoneLogo}
                                    style={{ width: '2rem' }}
                                  ></img>
                                </div>
                                {!isVoice ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() =>
                                      setIsPhoneSuite(!isAddPhoneSuite)
                                    }
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Telephony with Voice AI </h2>
                                    <span>
                                      Automate phone communication using Voice
                                      AI
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length == 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('EmailDirectLine') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={EmailLogo}
                                    style={{ width: '2.5rem' }}
                                  ></img>
                                </div>
                                {!isEmail ?
                                  <Button
                                    size="xs"
                                    color="outline-grey"
                                  >
                                    <span>Not Available</span>
                                  </Button>
                                  :
                                  <Button
                                    size="xs"
                                    color="primary"
                                    outline
                                    onClick={() => setIsAddEmail(!isAddEmail)}
                                  >
                                    <IntlMessages id="dashboards.connect" />
                                  </Button>
                                }
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Outlook Add-on</h2>
                                    <span>
                                      Effortless email replies powered by AI,
                                      right inside the familiar Outlook
                                      environment.
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                  {isVoucherEngine && domains.length === 1 ? (
                    ''
                  ) : (
                    <>
                      {filterItem('TeamsApp') && (
                        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                          <Card
                            className="d-flex flex-row integrationcard"
                            style={{ height: '215px' }}
                          >
                            <CardBody className="mt-0">
                              <div className="connect-title">
                                <div className="integrationChannel mt-2">
                                  <img
                                    src={TeamsApp_Logo}
                                    style={{ width: '2rem' }}
                                  ></img>
                                </div>
                                <Button
                                  size="xs"
                                  color="primary"
                                  outline
                                  onClick={() =>
                                    setIsAddTeamsApp(!isAddTeamsApp)
                                  }
                                >
                                  <IntlMessages id="dashboards.connect" />
                                </Button>
                              </div>
                              <Row>
                                <Colxx
                                  xxs="12"
                                  className="mb-5"
                                  style={{ marginTop: '2rem' }}
                                >
                                  <div className="text-left">
                                    <h2>Microsoft Teams</h2>
                                    <span>
                                      Add Chatbot as a Teams contact and ask the
                                      questions to search the Knowledge Hub
                                    </span>
                                  </div>
                                </Colxx>
                              </Row>
                            </CardBody>
                          </Card>
                        </Colxx>
                      )}
                    </>
                  )}
                </Fragment>
              </Row>
            </TabPane>
            <TabPane
              tabId="Connected Channels"
              className="chat-app-tab-pane"
              style={{ background: 'none' }}
            >
              <Row className="m-2 my-3">
                {isLoading ? (
                  <div className="text-center loading" />
                ) : (

                  <Fragment>

                    {integrations && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(integrations, CHANNEL_NAMES.integrations).map((integration, index) => (
                        <WebIntegrationThumb
                          key={index}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                          propertyId={propertyId}
                        />
                      ))
                      : null}
                    {weChatintegrations &&
                      (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(weChatintegrations, CHANNEL_NAMES.weChatintegrations).map((integration, index) => (

                        <Fragment key={index}>
                          <WechatIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {fbintegrations && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(fbintegrations, CHANNEL_NAMES.fbintegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <FacebookIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {phoneintegrations &&
                      (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(phoneintegrations, CHANNEL_NAMES.phoneintegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <PhoneIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {gbintegrations && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(gbintegrations, CHANNEL_NAMES.gbintegrations).map((integration, index) => (
                        <GoogleBusinessIntegrationThumb
                          key={index}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      ))
                      : null}
                    {whatsAppintegrations && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(whatsAppintegrations, CHANNEL_NAMES.whatsAppintegrations).map((integration, index) => (
                        <WhatsappIntegrationThumb
                          key={index}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      ))
                      : null}
                    {SMSintegrations && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(SMSintegrations, CHANNEL_NAMES.Smsintegrations).map((integration, index) => (
                        <SMSIntegrationThumb
                          key={index}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      ))
                      : null}
                    {helpCenterIntegration && (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(helpCenterIntegration, CHANNEL_NAMES.helpCenterIntegration).map((integration, index) => (
                        <HelpCenterIntegrationThumb
                          key={index}
                          locale={locale}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      ))
                      : null}

                    {helpCenterGroupIntegration &&
                      (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(helpCenterGroupIntegration, CHANNEL_NAMES.helpCenterGroupIntegration).map((integration, index) => (
                        <Fragment key={index}>
                          <HelpCenterGroupIntegrationThumb
                            locale={locale}
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {phoneSuiteIntegrations
                      ? applyFilters(phoneSuiteIntegrations, CHANNEL_NAMES.phoneSuiteIntegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <PhoneSuiteIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                            imageDomain={imageDomain}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {instagramIntegrations
                      ? applyFilters(instagramIntegrations, CHANNEL_NAMES.instagramIntegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <InstagramIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {tiktokIntegrations
                      ? applyFilters(tiktokIntegrations, CHANNEL_NAMES.tiktokIntegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <TiktokIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {gmailIntegrationList
                      ? applyFilters(gmailIntegrationList, CHANNEL_NAMES.gmailIntegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <GmailIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {gmailIntegrations
                      ? applyFilters(gmailIntegrations, CHANNEL_NAMES.gmailIntegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <GmailIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            refreshConnection={RefreshConnection}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                    {emailIntegration
                      ? applyFilters(emailIntegration, CHANNEL_NAMES.emailIntegration).map((integration, index) => (
                        <Fragment key={index}>
                          <EmailIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                            title={'Outlook Plugin'}
                          ></EmailIntegrationThumb>
                        </Fragment>
                      )
                      )
                      : null}
                    {filterItem('EmailAssistant') && unifiedEmailIntegrationsList
                      ? applyFilters(unifiedEmailIntegrationsList, CHANNEL_NAMES.emailIntegration).map((integration, index) => (
                        <Fragment key={index}>
                          <EmailIntegrationThumb
                            integration={integration}
                            propertyId={propertyId}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                            title={'Email Automation with Microsoft 365'}
                          ></EmailIntegrationThumb>
                        </Fragment>
                      )
                      )
                      : null}
                    {teamsAppintegrations &&
                      (!isVoucherEngine || domains.length > 1)
                      ? applyFilters(teamsAppintegrations, CHANNEL_NAMES.teamsAppintegrations).map((integration, index) => (
                        <Fragment key={index}>
                          <TeamsAppIntegrationThumb
                            integration={integration}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                          />
                        </Fragment>
                      )
                      )
                      : null}
                  </Fragment>
                )}
              </Row>
            </TabPane>
          </TabContent>
        </Fragment>
      </Fragment>

      <StripeIntregation
        formLabel="Payment Methods in NewZeland"
        paymentmodelvisible={paymentmodelvisible}
        toggle={() => {
          setpaymentmodelvisible(!paymentmodelvisible);
        }}
        allProperties={allProperties}
        integration={stripeIntregation}
        LoadIntegrations={LoadIntegrations}
        refreshConnection={RefreshConnection}
        handleProerptyId={handleProerptyId}
        handlePayment={() => {
          checkConnection();
          setpaymentmodelvisible(!paymentmodelvisible);
          setcreateaccountModel(!createaccountModel);
        }}
      />
      <OpenAccount
        visible={createaccountModel}
        toggle={() => {
          setcreateaccountModel(!createaccountModel);
        }}
        createAccount={() => {
          handlePayment();
        }}
        deleteAccount={() => {
          stripeIntregation &&
            stripeIntregation.map((integration, index) => {
              handleDelete(integration.id);
              RefreshConnection(
                'Archieve',
                integration.channelDetails.stripeCustomerId
              );
            });
        }}
        isConnected={isConnected}
      />
      {
        messageVisible && (
          <ShowMessage
            formbody={'Connection established'}
            visible={messageVisible}
            isStripe={true}
            toggle={() => {
              localStorage.removeItem('ShowMessage');
              localStorage.removeItem('Message');
              setmessageVisible(!messageVisible);
            }}
          />
        )
      }
      {
        confirmMessage && (
          <ShowMessage
            formbody={'Connection established'}
            visible={confirmMessage}
            isStripe={false}
            toggle={() => {
              localStorage.removeItem('ShowConfirm');
              localStorage.removeItem('Message');
              setConfirmMeesage(!confirmMessage);
            }}
          />
        )
      }
      <ShowMessage
        formbody={'Connection established'}
        visible={cloudBedsVisible}
        logo={CloudBeds_Logo}
        toggle={() => {
          localStorage.removeItem('ShowCloudbedsMessage');
          setCloudsBedsVisible(!cloudBedsVisible);
        }}
      />
      <ShowMessage
        formbody={'Connection established'}
        visible={instagramVisible}
        logo={InstaLogo}
        toggle={() => {
          localStorage.removeItem('ShowInstagramMessage');
          setInstagramVisible(!instagramVisible);
        }}
      />
      <ShowMessage
        formbody={'You are already connected with Google Analytics.'}
        visible={isGoogleAnalyticsAvailable}
        logo={Analytics_Logo}
        toggle={() => {
          setIsGoogleAnalyticsAvailable(!isGoogleAnalyticsAvailable);
        }}
      />
      <ShowWarningMessage
        visible={warningMsgVisible}
        toggle={toggleWarning}
      ></ShowWarningMessage>
    </Fragment >
  );
}
const mapStateToProps = ({ settings, service }) => {
  let {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    locale,
    integrationTab,
    serviceProvider,
  } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    locale,
    integrationTab,
    serviceProvider,
    featuresUrl,
  };
};

export default injectIntl(
  connect(mapStateToProps, { changeTabs, fetchServiceRequest })(Channel)
);
